import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionBid, AuctionItem, AuctionService, BalanceService, config } from '@fgb/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgbcl-auction-purchase-confirmation',
  standalone: true,
  imports: [CommonModule, FGBSharedModule, PipesModule, DirectivesModule],
  templateUrl: './auction-purchase-confirmation.component.html',
})
export class AuctionPurchaseConfirmationComponent {
  @Input() auctionItem: AuctionItem;
  @Input() bidAmount: number;
  @Input() amountToDebit: number;

  readonly modal = inject(NgbActiveModal);
  private readonly auctionService = inject(AuctionService);
  private readonly balanceService = inject(BalanceService);
  readonly config = config;

  submitBid(): void {
    const bid = new AuctionBid(this.auctionItem.Id, +this.bidAmount);
    this.auctionService
      .postBid(bid)
      .toPromise()
      .then(() => {
        this.balanceService.debitBalance(this.config.purseConfig.virtualLoyalty, this.amountToDebit);
        this.modal.close();
      });
  }
}
